// Copyright (c) 2026 DMG L&D, LLC. All rights reserved.
// Proprietary and confidential. See LICENSE for terms.

/**
 * URL-encode a UTF-8 string (given as bytes), returned as UTF-8 bytes.
 *
 * Encodes all characters except unreserved ones (A-Z a-z 0-9 - _ . ~).
 */

import type { Bytes } from '../types.ts';

export interface UrlEncodeOptions {
  /** Use encodeURIComponent semantics (default: true). If false, uses encodeURI (preserves path separators). */
  component?: boolean;
}

export async function urlEncode(
  input: Bytes,
  opts: UrlEncodeOptions = {},
): Promise<Bytes> {
  if (!(input instanceof Uint8Array)) {
    throw new Error('url.encode: input must be a Uint8Array');
  }

  const str = new TextDecoder().decode(input);
  const encoded = (opts.component ?? true) ? encodeURIComponent(str) : encodeURI(str);
  return new TextEncoder().encode(encoded);
}
